const STATUS_PATH = '/system/status';
const RETRY_INTERVAL = 30000;
const DEFAULT_MESSAGE = 'O sistema está passando por uma atualização. Tente novamente em alguns minutos.';

let overlay = null;

export function isMaintenanceError(error) {
    return error?.response?.status === 503 && error.response.data?.maintenance === true;
}

export function showMaintenance(baseUrl, message) {
    if (overlay) {
        return;
    }

    overlay = document.createElement('div');
    overlay.setAttribute('role', 'alertdialog');
    overlay.setAttribute('aria-live', 'assertive');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(15,23,42,.72);font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;';

    const card = document.createElement('div');
    card.style.cssText = 'width:100%;max-width:420px;padding:32px 24px;border-radius:12px;background:#fff;color:#1f2937;text-align:center;box-shadow:0 20px 40px rgba(0,0,0,.25);';

    const title = document.createElement('h2');
    title.textContent = 'Sistema em atualização';
    title.style.cssText = 'margin:0 0 12px;font-size:20px;font-weight:600;line-height:1.3;';

    const text = document.createElement('p');
    text.textContent = message || DEFAULT_MESSAGE;
    text.style.cssText = 'margin:0 0 16px;font-size:15px;line-height:1.5;';

    const hint = document.createElement('p');
    hint.textContent = 'A página será recarregada automaticamente quando o sistema voltar.';
    hint.style.cssText = 'margin:0;font-size:13px;line-height:1.4;color:#6b7280;';

    card.append(title, text, hint);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    const statusUrl = new URL(STATUS_PATH, new URL(baseUrl, window.location.href).origin).toString();

    const check = async () => {
        const isBack = await fetch(statusUrl, { cache: 'no-store', headers: { Accept: 'application/json' } })
            .then((response) => response.ok)
            .catch(() => false);

        if (isBack) {
            window.location.reload();
            return;
        }

        setTimeout(check, RETRY_INTERVAL);
    };

    setTimeout(check, RETRY_INTERVAL);
}
